import React, { Component } from 'react'
import { Table, OverlayTrigger, Tooltip, Button } from 'react-bootstrap'
import SimpleTreeSelect from '../../commons/simpleForm/SimpleTreeSelect'
import IDocCarPagination from '../../commons/iDocCarPagination'
import { formatPercent } from '../../../util/utils'
import CodeCommissionMastersModalPage from '../../../containers/masters/CodeCommission/CodeCommissionMastersModalPage'
import MapSectionsMasters from '../../../util/map-sections-masters'

class CodeCommissionMasters extends Component {
  constructor () {
    super()
    this.state = {
      uoId: null,
      filters: {
        page: 1,
        pageSize: 10,
        orderBy: 'organizedUnitName',
        orderDirection: 'ASC'
      },
      dataList: {
        items: [],
        pages: 0,
        count: 0
      }
    }
  }

  componentDidMount () {
    this.props.actions.fetchOrganizedUnitsAll()
    this.props.actions.fetchcodeCommissionMasters(null, 1, 10, 'organizedUnitName', 'ASC')
  }

  handleOrganizedUnitChange (uoId) {
    this.setState({ uoId })
    const { pageSize, orderBy, orderDirection } = this.state.filters
    this.props.actions.fetchcodeCommissionMasters(uoId, 1, pageSize, orderBy, orderDirection)
  }

  fetchCodeCommissionList (value) {
    this.setState({ filters: { ...this.state.filters, page: value } })
    const { pageSize, orderBy, orderDirection } = this.state.filters
    this.props.actions.fetchcodeCommissionMasters(this.state.uoId, value, pageSize, orderBy, orderDirection)
  }

  changeOrder (orderBy) {
    var changeDirection = this.state.filters.orderBy === orderBy
    var orderDirection = 'ASC'

    if (changeDirection) {
      orderDirection = this.state.filters.orderDirection === 'ASC' ? 'DESC' : 'ASC'
    }

    this.setState({ filters: { ...this.state.filters, orderBy, orderDirection } })
    const { page, pageSize } = this.state.filters

    this.props.actions.fetchcodeCommissionMasters(this.state.uoId, page, pageSize, orderBy, orderDirection)
  }

  getSortIcon (column = '') {
    if (this.state.filters.orderBy === column) {
      return this.state.filters.orderDirection === 'ASC' ? 'ico-sort-selected-asc' : 'ico-sort-selected-desc'
    }

    return 'ico-sort'
  }

  render () {
    const {
      t, codeCommissionMastersList,
      actions: { deleteCodeComission, openCodeCommissionModal },
      combos: { UOTreeCombo },
      codeCommissionFields: { page }
    } = this.props

    const secMapMasters = MapSectionsMasters.find(function (s) { return s.page === 'codeCommissionMasterPage' })
    const tKey = 'MASTERS.CODE_COMMISSION.'
    const pKey = 'MASTERS.CUSTOM_FIELDS.'
    const editTooltip = (<Tooltip id="editTooltip">{t('MASTERS.EDIT')}</Tooltip>)
    const deleteTooltip = (<Tooltip id="deleteTooltip">{t('MASTERS.DELETE')}</Tooltip>)

    return (
      <div className="inner-results-panel">
        <div className="section-results-header">
          <div className="section-header-title">
            <OverlayTrigger placement="right" overlay={<Tooltip id="editProductTooltip">{`${t((this.props.hideMenu ? 'GLOBAL.TABLES.SHOW_INNER_MENU' : 'GLOBAL.TABLES.HIDE_INNER_MENU'))}`}</Tooltip>}>
              <a onClick={() => this.props.toogleInnerMenu()} className={this.props.hideMenu ? 'collapseBtn' : 'collapseBtn closeInnerMenu'}><i className={this.props.hideMenu ? 'iDocIcon-Open-inner-menu' : 'iDocIcon-Close-inner-menu'}></i></a>
            </OverlayTrigger>
            <h4>{t(`${secMapMasters.title}`)}</h4>
            <Button
              className="_Btn new"
              onClick={() => openCodeCommissionModal(null)}>
              <i className='iDocIcon-add-plus'></i> {t('MASTERS.ADD')} {t(`${secMapMasters.title}`)}
            </Button>
          </div>
          <div className='filters'>
            <div className="search-form">
              <div className='colWidth-100 marg-top-20'>
                <SimpleTreeSelect
                  colSm={4}
                  controlLabel={t('DOSSIER_COMPONENTS.HEADER.UO')}
                  placeholder={t('DOSSIER_COMPONENTS.HEADER.UO')}
                  options={UOTreeCombo}
                  searchPlaceholder={t('DOSSIER_COMPONENTS.HEADER.UO')}
                  value={this.state.uoId ? this.state.uoId.toString() : null}
                  onInputChange={(value) => this.handleOrganizedUnitChange(value)}
                  className='dashboard-select'
                />
              </div>

            </div>
          </div>
        </div>

        <CodeCommissionMastersModalPage
          uoId={this.state.uoId}
        />
        {(codeCommissionMastersList?.count !== 0) &&
        <Table sm={12} className="editable-table" hover responsive>
          <thead>
            <tr>
              <th className='td20per' onClick={() => { this.changeOrder('organizedUnitName') }}>{t('DOSSIER_COMPONENTS.HEADER.UO')}
                <i className={this.getSortIcon('organizedUnitName')} /></th>
              <th className='td15per' onClick={() => { this.changeOrder('code') }}>{t(`${tKey}CODE`)}
                <i className={this.getSortIcon('code')} /></th>
              <th className='td25per' onClick={() => { this.changeOrder('description') }}>{t('MASTERS.DESCRIPTION')}
                <i className={this.getSortIcon('description')} /></th>
              <th className='td10per' onClick={() => { this.changeOrder('fixedPercentage') }}>{t(`${tKey}FIXED_PERCENTAGE`)}
                <i className={this.getSortIcon('fixedPercentage')} /></th>
              <th className='td10per' onClick={() => { this.changeOrder('quantitativePercentage') }}>{t(`${tKey}QUANTITATIVE_PERCENTAGE`)}
                <i className={this.getSortIcon('quantitativePercentage')} /></th>
              <th className='td10per' onClick={() => { this.changeOrder('qualitativePercentage') }}>{t(`${tKey}QUALITATIVE_PERCENTAGE`)}
                <i className={this.getSortIcon('qualitativePercentage')} /></th>
              <th className='td10per actions' >{t('DOSSIER_COMPONENTS.ACCESSORIES.ACTIONS')}</th>
            </tr>
          </thead>
          <tbody>
            {codeCommissionMastersList?.items && codeCommissionMastersList?.items.map((codeCommissionMaster, idx) => (
              <tr key={idx} >
                <td className='td20per'>{codeCommissionMaster.organizedUnitName}</td>
                <td className='td15per'>{codeCommissionMaster.code}</td>
                <td className='td25per'>{codeCommissionMaster.description}</td>
                <td className='td10per'>{formatPercent(codeCommissionMaster.fixedPercentage)}</td>
                <td className='td10per'>{formatPercent(codeCommissionMaster.quantitativePercentage)}</td>
                <td className='td10per'>{formatPercent(codeCommissionMaster.qualitativePercentage)}</td>
                <td className='td10per actions'>
                  <div>
                    <OverlayTrigger placement="left" overlay={editTooltip}>
                      <a className='_Btn accept stk o-icn ' onClick={() => openCodeCommissionModal(codeCommissionMaster)}>
                        <i className="iDocIcon-edit" />
                      </a>
                    </OverlayTrigger>
                    <OverlayTrigger placement="left" overlay={deleteTooltip}>
                      <a className='_Btn cancel stk o-icn ' onClick={() => deleteCodeComission(codeCommissionMaster.commissionCancellationCodeId, this.state.uoId)}>
                        <i className="iDocIcon-delete-forever" />
                      </a>
                    </OverlayTrigger>
                  </div>
                </td>
              </tr>
            ))}

          </tbody>
        </Table>
        }
        {(codeCommissionMastersList?.items === null || codeCommissionMastersList?.items === undefined || codeCommissionMastersList?.items?.length === 0) &&
            <p className="no_results" >{t(`${pKey}RESULTS_NOT_FOUND`)}</p>
        }
        <div className="section-users-footer">
          <nav key={1} className="text-center">
            <IDocCarPagination
              id="btn_pag_sales"
              page={page}
              pagesCount={codeCommissionMastersList?.pages ?? 0}
              totalRows={codeCommissionMastersList?.count ?? 0}
              onSelectAction={(value) => this.fetchCodeCommissionList(value)}
            />
          </nav>
        </div>
      </div>
    )
  }
}

export default CodeCommissionMasters
